export default function LoadingScreen({ variant = "page", text }) {
  const isOverlay = variant === "overlay";

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2rem',
        width: '100%',
        height: isOverlay ? '100%' : '100vh',
        backgroundColor: '#000',  // Match your VNC background
      }}
    >
      {/* Logo */}
      <img
        src={`${window.location.origin}/assets/tocaroLogo.webp`}
        alt="Tocaro Blue"
        style={{
          height: '48px',
          width: 'auto',
          userSelect: 'none',
        }}
        draggable={false}
      />

      {/* Spinner */}
      <div className="spinner" />

      {/* Title */}
      <h2
        style={{
          fontWeight: 500,
          letterSpacing: '0.025em',
          color: '#4b5563',
          fontSize: '18px',
          margin: 0,
        }}
      >
        DevKit Dashboard
      </h2>

      {text && (
        <p
          style={{
            color: '#9ca3af',
            fontSize: '14px',
            margin: 0,
          }}
        >
          {text}
        </p>
      )}

      <style>{`
        @keyframes spin {
          0%   { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .spinner {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          border: 4px solid #374151;
          border-top-color: #3b82f6;
          animation: spin 0.9s linear infinite;
        }
      `}</style>
    </div>
  );
}